import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import DistributorSidebar from '../components/DistributorSidebar';
import Header from '../components/Header';
import distributorService from '../services/DistributorService';

const DistributorLayout = ({ onLogout }) => {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [showMarquee, setShowMarquee] = useState(false);
  const [portalLoginStatus, setPortalLoginStatus] = useState(null);

  useEffect(() => {
    // Handle window resize
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setSidebarVisible(false); // Hide mobile sidebar on desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch portal login status
    const fetchPortalLoginStatus = async () => {
      const response = await distributorService.getPortalLoginStatus();
      if (response.success) {
        setShowMarquee(true);
        setPortalLoginStatus(response.portalLoginStatus);
      } else {
        setShowMarquee(false);
        setPortalLoginStatus(null);
      
      }
    };

    fetchPortalLoginStatus();
  }, []);

  const toggleSidebar = () => {
    // Check if we're on mobile (window width < 992px)
    const isMobile = window.innerWidth < 992;
    
    if (isMobile) {
      setSidebarVisible(!sidebarVisible);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <div className="d-flex">
      <DistributorSidebar 
        collapsed={sidebarCollapsed} 
        visible={sidebarVisible}
        onLogout={onLogout}
      />
      {sidebarVisible && (
        <div 
          className="sidebar-overlay d-lg-none" 
          onClick={() => setSidebarVisible(false)}
        ></div>
      )}
      <div className="flex-grow-1">
        <Header
          onToggleSidebar={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
          sidebarVisible={sidebarVisible}
          onLogout={onLogout}
        />
        {(showMarquee && portalLoginStatus) && (
          <div className="portal-status-marquee">
            <div className="marquee-wrapper">
              <div className="marquee-content">
                <span className="marquee-text">
                  Portal Status: Portal logout please login again
                </span>
              </div>
            </div>
            <button
              className="marquee-config-btn"
              onClick={() => navigate('/distributor/config/portal-login')}
            >
              <i className="fas fa-cog me-1"></i>
              Set Password
            </button>
          </div>
        )}
        <div className={`dms-dashboard ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DistributorLayout;